/* eslint-disable no-console */
import type { Tracker, UserData } from './tracker'

export class ConsoleTracker implements Tracker {
  trackerId = 'console'
  track(eventName: string, eventProperties: Record<string, any>) {
    console.debug(`Track: ${eventName}`, eventProperties)
  }

  identify(userData: UserData) {
    console.debug('Identify:', userData)
  }

  async hasFeatureFlag(name: string): Promise<boolean> {
    if (name === 'bookings-standalone') return false

    console.debug('Checking existing feature flag:', name)
    return true // no-op
  }

  clear() {
    console.debug('Tracker cleared')
  }

  getRawTracker() {
    console.debug('ConsoleTracker::getRawTracker()')
  }
}
